module.exports = __webpack_public_path__ + "img/infratel.acf2f5e9.jpg";